
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from "react-redux";
import { PersistGate } from 'redux-persist/integration/react'
import { store, persistor } from "./stores/store";

import Partners from './screens/Partners'

import { BrowserRouter as Router } from 'react-router-dom'
import * as serviceWorker from './serviceWorker';

import {getInitRouteInfo} from "./_services/partners.service";

const {isInitRoute: isPartnerInitialRoute, partner} = getInitRouteInfo();

const render = (component) => {
  ReactDOM.render(
    <Provider store={store}>
      <PersistGate loading={<p>loading...</p>} persistor={persistor}>
        <Router>
          <React.StrictMode>
            {component}
          </React.StrictMode>
        </Router>
      </PersistGate>
    </Provider>,
      document.getElementById('root')
  );
  serviceWorker.unregister();
}

if(!isPartnerInitialRoute){
  import('./App')
      .then(App => {
        render(<App.default/>)
      })
}else{
     render(<Partners partner={partner}/>)
}
